import { Chip } from '@mui/material';
import classNames from 'clsx';

type VNLiveStatusBadgeProps = {
  /** When true, positions the badge as a video player overlay. */
  overlay?: boolean;
  className?: string;
};

const VNLiveStatusBadge = ({ overlay = false, className }: VNLiveStatusBadgeProps) => (
  <Chip
    size="small"
    variant="filled"
    color="error"
    className={classNames('vn-live-status-badge', { 'vn-live-status-badge--overlay': overlay }, className)}
    label={
      <span className="vn-live-status-badge__label">
        <span className="vn-live-status-badge__dot" aria-hidden="true" />
        Live
      </span>
    }
  />
);

export default VNLiveStatusBadge;
